(function () {
	'use strict';

	angular.module('dcApp').factory('ProjectDuplicateAdapter', [
		'$rootScope',
		'ELEMENT',
		function ($rootScope, ELEMENT) {
			const ProjectDuplicateAdapter = {};
			ProjectDuplicateAdapter.getStats = getStats;

			function getStats(gdStatsRes, hdStatsRes, projectDataRes) {
				return {
					projectLabel: projectDataRes.metadata.label,
					projectDescription: projectDataRes.metadata.description,
					projectVersion: projectDataRes.metadata,
					currentUser: $rootScope.account.preferredUsername,
					critical: projectDataRes.advanced_params
						? projectDataRes.advanced_params.critical
						: true,
					confidential: projectDataRes.advanced_params
						? projectDataRes.advanced_params.confidential
						: true,
					stats: {
						connector: {
							count: gdStatsRes.connector || 0,
							hasAccess: $rootScope.havePermission(
								ELEMENT.permissions.connector
							),
						},
						repository: {
							count: gdStatsRes.repository || 0,
							hasAccess: $rootScope.havePermission(
								ELEMENT.permissions.repository
							),
						},
						exportTemplate: {
							count: gdStatsRes.export_template || 0,
							hasAccess: $rootScope.havePermission(
								ELEMENT.permissions.export_template
							),
						},
						entity: {
							count: gdStatsRes.entity || 0,
							hasAccess: $rootScope.havePermission(ELEMENT.permissions.entity),
						},
						datablock: {
							count: gdStatsRes.datablock || 0,
							hasAccess: $rootScope.havePermission(
								ELEMENT.permissions.datablock
							),
						},
						sharedElements: {
							count: (hdStatsRes.data_link || 0) + (hdStatsRes.exposition || 0),
							hasAccess: $rootScope.havePermission(
								ELEMENT.permissions.datalink,
								ELEMENT.permissions.exposition
							),
						},
						hdElements: {
							count: countHdElements(hdStatsRes) || 0,
							hasAccess:
								$rootScope.havePermission(ELEMENT.permissions.map) &&
								$rootScope.havePermission(ELEMENT.permissions.timeline) &&
								$rootScope.havePermission(ELEMENT.permissions.media) &&
								$rootScope.havePermission(ELEMENT.permissions.grid) &&
								$rootScope.havePermission(ELEMENT.permissions.chart),
						},
						dashboard: {
							count: hdStatsRes.dashboard || 0,
							hasAccess: $rootScope.havePermission(
								ELEMENT.permissions.dashboard
							),
						},
					},
				};
			}

			function countHdElements(list) {
				let hdElementsSum = 0;
				for (const obj in list) {
					if (
						obj !== 'dashboard' &&
						obj !== 'datalink' &&
						obj !== 'exposition'
					) {
						hdElementsSum = list[obj] + hdElementsSum;
					}
				}
				return hdElementsSum;
			}

			return ProjectDuplicateAdapter;
		},
	]);
})();
